import { render, staticRenderFns } from "./ParamSet.vue?vue&type=template&id=28d4db32&scoped=true&"
import script from "./ParamSet.vue?vue&type=script&lang=js&"
export * from "./ParamSet.vue?vue&type=script&lang=js&"
import style0 from "./ParamSet.vue?vue&type=style&index=0&id=28d4db32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d4db32",
  null
  
)

export default component.exports